import React, { useContext, useEffect, useState } from 'react'
import GoogleMapReact from 'google-map-react'
import { MapWrapper } from "../../styles/google-map-style";
import { FaMapMarker } from "react-icons/fa"
import { firebaseConfig } from '../../firebase-config';
import { JobContext } from '../../contexts/JobContext';
import { Garage } from '../../models/garage';
import { Button, Modal } from 'react-bootstrap';
import StarRatingComponent from 'react-star-rating-component';
import { MdStar, MdStarHalf, MdStarOutline } from 'react-icons/md';
import { PrimaryColor } from '../../utils/constants';
import { MdDirections, } from 'react-icons/md';

const LocationPin = ({ garage, lat, lng, key, onSelect}: { garage: Garage, lat: number, lng: number, key: number, onSelect: () => void, }) => {

  return (  
    <div  style={{ marginLeft: -10, marginTop: -30 }}>
      <FaMapMarker onClick={() => onSelect()} size={30} style={{ filter: `grayscale(0%)`, color: "brown" }} />
    </div>
  );
}

const GarageMap = ({  height, zoomLevel }: { height?: number, zoomLevel?: number }) => {

  const {garages, serviceZipCodes} = useContext(JobContext);
  const [currentGarage, setCurrentGarage] = useState<Garage>();

  const today = currentGarage?.timing?.[new Date().getDay() - 1];
  let nextDay = currentGarage?.timing?.[new Date().getDay() === 7 ? 0 : new Date().getDay()];
  let nextDayDate = new Date().getDay() === 7 ? 0 : new Date().getDay();
  if(nextDay?.openingHours === 0){
    nextDay = currentGarage?.timing?.[new Date().getDay() === 7 ? 1 : new Date().getDay() === 6 ? 0 : (new Date().getDay() + 1)];
    nextDayDate = new Date().getDay() === 7 ? 1 : new Date().getDay() === 6 ? 0 : (new Date().getDay() + 1);
  }
  if(nextDay?.openingHours === 0){
    nextDay = currentGarage?.timing?.[new Date().getDay() === 7 ? 2 : new Date().getDay() === 6 ? 1 : new Date().getDay() === 5 ? 0 : (new Date().getDay() + 2)];
    nextDayDate = new Date().getDay() === 7 ? 2 : new Date().getDay() === 6 ? 1 : new Date().getDay() === 5 ? 0 : (new Date().getDay() + 2);
  }
  const currentHour = new Date().getHours();
  const currentMinute = new Date().getMinutes();

  const open = (today?.openingHours < currentHour || (today?.openingHours === currentHour && today?.openingMinutes <= currentMinute)) 
                && (today?.closingHours > currentHour || (today?.closingHours === currentHour && today?.closingMinutes >= currentMinute))
  
  const getLocalHours = (hours: number, minutes: number) => {
    if(hours > 12){
      return `0${(hours - 12)}:${minutes >= 10 ? minutes : `0${minutes}`}PM`;
    }else if(hours === 12) {
      return `${(hours)}:${minutes >= 10 ? minutes : `0${minutes}`}PM`;
    }else if(hours < 12 && hours >= 10) {
      return `${(hours)}:${minutes >= 10 ? minutes : `0${minutes}`}AM`;
    }else{
      return `0${(hours)}:${minutes >= 10 ? minutes : `0${minutes}`}AM`;
    }
  }

  const getLocalHour = (hours: number) => {
    if(hours > 12){
      return `${(hours - 12)}PM`;
    }else if(hours === 12) {
      return `${(hours)}PM`;
    }else {
      return `${(hours)}AM`;
    }
  }


  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${currentGarage?.latitude},${currentGarage?.longitude}`;

  return (
    <>
      <MapWrapper>
        <div className="map">
          <div className="google-map" style={{ height: height ?? '' }}>
            <GoogleMapReact
              bootstrapURLKeys={{ key: firebaseConfig.apiKey }}
              center={{ lat: 29.41877, lng: -98.50457 }}
              defaultZoom={zoomLevel ?? 10}
            >
              {garages?.length > 0 && garages?.map((garage, index) => (
                <LocationPin
                  lat={garage.latitude}
                  lng={garage.longitude}
                  garage={garage}
                  key={index}
                  onSelect={() => {setCurrentGarage(garage);}}
                />
              ))}
            </GoogleMapReact>
          </div>
        </div>
      </MapWrapper>
      <Modal show={!!currentGarage} onHide={() => setCurrentGarage(undefined)}>
        <Modal.Header closeButton>
          <Modal.Title style={{fontWeight: "bold"}}>
            {currentGarage?.garageName}
            <p style={{display: "flex", fontWeight: "normal", fontSize: 18}}>
              <span style={{marginRight: 3}}>{currentGarage?.rating}</span>
              <StarRatingComponent
                renderStarIcon={(next: number, prev: number, name: any) => {
                    return (prev > next - 1 ? <MdStar color={PrimaryColor} size={20} /> : <MdStarOutline color={PrimaryColor} size={20} />)
                }}
                renderStarIconHalf={() => {
                    return <MdStarHalf size={20} color={PrimaryColor} />
                }}
                name="currentgarage-rating"
                starCount={5}
                value={currentGarage?.rating ?? 0}
              />
              {!currentGarage?.googleRatingUrl && <span style={{marginLeft: 3}}>({currentGarage?.ratedBy ?? 0})</span>}
              {!!currentGarage?.googleRatingUrl && <span style={{marginLeft: 3}}>{currentGarage?.ratedBy ?? 0}</span>}
              {!!currentGarage?.googleRatingUrl && <span style={{marginLeft: 3}}><a target='_blank' rel='noreferrer' href={currentGarage?.googleRatingUrl}>Google Reviews</a></span>}
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <span style={{fontWeight: "bold"}}>Address: </span>
            {currentGarage?.address1 ?? ""}
            {currentGarage?.address2 ?? ""}{", "}
            {currentGarage?.city ?? ""}{", "}
            {currentGarage?.state ?? ""}{", "}
            {currentGarage?.zipCode ?? ""}
          </p>
          <p>
            <span style={{fontWeight: "bold"}}>Hours: </span> M-F, {getLocalHour(currentGarage?.timing?.[0]?.openingHours)} to {getLocalHour(currentGarage?.timing?.[0]?.closingHours)} and Saturday, {getLocalHour(currentGarage?.timing?.[5]?.openingHours)} to {getLocalHour(currentGarage?.timing?.[5]?.closingHours)}
          </p>
          <p>
            <span style={{fontWeight: "bold"}}>Phone: </span>
            <a href={`tel:${currentGarage?.phoneNumber}`}>{currentGarage?.phoneNumber}</a>
          </p>

        </Modal.Body>
        <Modal.Footer>
          <a href={directionsUrl} target='_blank' rel='noreferrer'>
            <button className="w-100 w-md-auto d-flex justify-content-center align-items-center btn btn-danger py-3 px-5" type='button'>Directions<div className="ms-2"> <MdDirections size={18} /> </div></button>
          </a>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default GarageMap;